module.exports = __webpack_public_path__ + "img/TransactionData1.c4a5c077.svg";